import { render, staticRenderFns } from "./NewFilesForm.vue?vue&type=template&id=4e8cca7e&scoped=true&"
import script from "./NewFilesForm.vue?vue&type=script&lang=js&"
export * from "./NewFilesForm.vue?vue&type=script&lang=js&"
import style0 from "./NewFilesForm.vue?vue&type=style&index=0&id=4e8cca7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8cca7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e8cca7e')) {
      api.createRecord('4e8cca7e', component.options)
    } else {
      api.reload('4e8cca7e', component.options)
    }
    module.hot.accept("./NewFilesForm.vue?vue&type=template&id=4e8cca7e&scoped=true&", function () {
      api.rerender('4e8cca7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/components/NewFilesForm.vue"
export default component.exports